{
  "extensionId": "jmdklobbijdfihdlhgnhbphpbkphimek",
  "legacyExtensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "storeURL": "https://chromewebstore.google.com/detail/gab-ai/jmdklobbijdfihdlhgnhbphpbkphimek"
}
